import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ImageDetails from '../ImageDetails';
import useInfiniteScroll from '../../hooks/useInfiniteScroll';
import CustomAlert from '../CustomAlert';
import MediaSkeleton from '../Skeletons/MediaSkeleton';

const styles = {
  container: {
    mt: '25px',
    p: 3,
    border: '2px solid #E0E0E0',
    borderRadius: '8px',
    position: 'relative',
    background:
      'linear-gradient(270deg, rgba(230, 250, 204, 0.3) -35.76%, rgba(219, 240, 231, 0.3) 44.43%, rgba(204, 230, 237, 0.3) 78.8%)',
  },
  resultsTitle: {
    color: 'secondary.main',
    fontWeight: 700,
    fontSize: '16px',
  },
  images: {
    maxHeight: '70vh',
    overflowY: 'auto',
    pr: '15px',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#2F5F7A',
      borderRadius: '4px',
      height: 'calc(100% - 200px)',
    },
    '&::-webkit-scrollbar-track': {
      background: '#bdbdbd',
      borderRadius: '4px',
    },
  },
  scrollToTop: {
    position: 'absolute',
    bottom: '60px',
    right: '60px',
    zIndex: 20000,
    backgroundColor: 'primary.main',
    '&:hover': {
      backgroundColor: 'primary.dark',
    },
  },
};
const Files = props => {
  const {
    media,
    totalCount,
    next,
    handleFetchMore,
    setSelectedImage,
    selectedImage,
    noMediaResult,
    paginationLoading,
  } = props;

  const { containerRef, showScroll, scrollToTop } = useInfiniteScroll(
    () => handleFetchMore(next),
    !!next
  );

  if (noMediaResult)
    return (
      <CustomAlert message="No results found. Try refining your search query." severity="info" />
    );

  if (!media?.length) return null;

  return (
    <Box sx={styles.container}>
      <Stack direction="row" alignItems="center" spacing="3px">
        <Box sx={styles.resultsTitle}>{totalCount > 1 ? 'Total Results :' : 'Total Result :'} </Box>
        <Box sx={styles.resultsTitle}>{totalCount}</Box>
      </Stack>

      <Box ref={containerRef} my={3} sx={styles.images}>
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
          {media.map(image => (
            <ImageDetails
              key={image.id}
              image={image}
              selectedImage={selectedImage}
              setSelectedImage={setSelectedImage}
            />
          ))}
        </Box>
        {paginationLoading && <MediaSkeleton />}
      </Box>

      {showScroll && (
        <Fab sx={styles.scrollToTop} onClick={scrollToTop} size="medium">
          <KeyboardArrowUpIcon />
        </Fab>
      )}
    </Box>
  );
};

export default Files;
